var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronDownGreen = function SvgChevronDownGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "9px",
    viewBox: "0 0 16 9",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon/search")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "acac-programslist-copy",
    transform: "translate(-812.000000, -212.000000)",
    fill: "#7fbe41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow/chevron-down",
    transform: "translate(810.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,11.538 L4.36948583,5.90384645 L4.29149841,5.83389567 C3.86187704,5.49856089 3.27457988,5.53282551 2.90385788,5.90323002 C2.49895936,6.30778178 2.49867826,6.96397088 2.90323002,7.36886939 L9.26686638,13.7379603 L9.34491275,13.8079608 C9.77480925,14.143462 10.362508,14.1089036 10.7331336,13.7379603 L17.09677,7.36886939 L17.1666653,7.29081064 C17.5016319,6.86090212 17.4668641,6.27363453 17.0961421,5.90323002 L16.9988434,5.81740002 C16.5881748,5.49836809 16.0009073,5.53313588 15.6305027,5.90385788 L10,11.538 Z",
    id: "Stroke-1"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronDownGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevronDownGreen.5029e40e.svg";
export { ForwardRef as ReactComponent };